export default {
  name: 'SiteApps',
  props: {
    siteName: {
      type: String,
      required: true,
    },
  },
};
